import { useQuery } from '@tanstack/react-query';
import { api } from './lib/api';
import { RouterProvider, useRouter } from './lib/router';
import { Shell } from './ui/Shell';
import { SignIn } from './ui/SignIn';
import { Toasts } from './ui/Toasts';

function Gate() {
  const me = useQuery({ queryKey: ['me'], queryFn: api.me, retry: false });
  if (me.isLoading) {
    return (
      <div className="h-full grid place-items-center text-zinc-500">
        <div className="text-sm">Loading. Try to look busy.</div>
      </div>
    );
  }
  if (!me.data?.user) {
    return <SignIn onSignedIn={() => me.refetch()} />;
  }
  return <Shell user={me.data.user} />;
}

export default function App() {
  return (
    <RouterProvider>
      <RouteAwareApp />
      <Toasts />
    </RouterProvider>
  );
}

function RouteAwareApp() {
  // Touch the router so app re-renders on nav.
  useRouter();
  return <Gate />;
}
